export default __webpack_public_path__ + "static/media/clock_icon.778f1d3a.svg";